import React from "react";

function BookDetailAdmin() {
  return (
    <div className="container" style={{ marginTop: "140px" }}>
      <h1> Book Detail Admin Side</h1>
      <p></p>
    </div>
  );
}

export default BookDetailAdmin;
